import {OrganizationConstantItem} from '@models/adminstration/organization/constants/organization-constant-item';
import {PortalGeneralSetting} from '@models/adminstration/organization/constants/portal-general-setting';

export class OrganizationConstant {
  tenantConstant: OrganizationConstantItem;
  portalSetting: PortalGeneralSetting;

  constructor() {
    this.tenantConstant = new OrganizationConstantItem();
    this.portalSetting = new PortalGeneralSetting();
  }
}
